/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Title1Inputs */

const id_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan Penggunaan Wajar untuk EGData App`)
};

const ms_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasar Penggunaan Adil untuk EGData App`)
};

const da_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use Politik for EGData App`)
};

const de_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair-Use-Richtlinie für EGData App`)
};

const en_us2_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use Policy for EGData App`)
};

const es_es2_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de uso justo de EGData App`)
};

const es_mx2_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de uso justo de EGData App`)
};

const fil_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patakaran sa Patas na Paggamit para sa EGData App`)
};

const fr_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique d'utilisation équitable de l'application EGData`)
};

const it_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica di Fair Use per EGData App`)
};

const hu_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use irányelv az EGData App számára`)
};

const nl_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use-beleid voor EGData App`)
};

const no_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retningslinjer for rimelig bruk for EGData App`)
};

const pl_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka dozwolonego użytku EGData App`)
};

const pt_br2_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de uso justo para aplicativo EGData`)
};

const pt_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Uso Justo da EGData App`)
};

const ro_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica de utilizare corectă a EGData App`)
};

const fi_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGData Appin kohtuullisen käytön käytäntö`)
};

const sv_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Policy för skälig användning för EGData App`)
};

const vi_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chính sách sử dụng hợp lý cho EGData App`)
};

const tr_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGData App Adil Kullanım Politikası`)
};

const cs_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zásady spravedlivého použití pro EGData App`)
};

const bg_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика за честна употреба на EGData App`)
};

const ru_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика добросовестного использования egdata.app`)
};

const uk_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Політика добросовісного використання EGData App`)
};

const ar_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سياسة الاستخدام العادل لتطبيق EGData`)
};

const hi_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGData ऐप के लिए उचित उपयोग नीति`)
};

const th_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นโยบายการใช้งานโดยชอบของ EGData App`)
};

const ja_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGData アプリのフェアユースポリシー`)
};

const zh_cn2_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGData App 合理使用政策`)
};

const zh_hant1_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGData App 合理使用政策`)
};

const ko_misc_fairuse_title1 = /** @type {(inputs: Misc_Fairuse_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGData 앱 공정 사용 정책`)
};

/**
* | output |
* | --- |
* | "Fair Use Policy for EGData App" |
*
* @param {Misc_Fairuse_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_title1 = /** @type {((inputs?: Misc_Fairuse_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_title1(inputs)
	if (locale === "ms") return ms_misc_fairuse_title1(inputs)
	if (locale === "da") return da_misc_fairuse_title1(inputs)
	if (locale === "de") return de_misc_fairuse_title1(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_title1(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_title1(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_title1(inputs)
	if (locale === "fil") return fil_misc_fairuse_title1(inputs)
	if (locale === "fr") return fr_misc_fairuse_title1(inputs)
	if (locale === "it") return it_misc_fairuse_title1(inputs)
	if (locale === "hu") return hu_misc_fairuse_title1(inputs)
	if (locale === "nl") return nl_misc_fairuse_title1(inputs)
	if (locale === "no") return no_misc_fairuse_title1(inputs)
	if (locale === "pl") return pl_misc_fairuse_title1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_title1(inputs)
	if (locale === "pt") return pt_misc_fairuse_title1(inputs)
	if (locale === "ro") return ro_misc_fairuse_title1(inputs)
	if (locale === "fi") return fi_misc_fairuse_title1(inputs)
	if (locale === "sv") return sv_misc_fairuse_title1(inputs)
	if (locale === "vi") return vi_misc_fairuse_title1(inputs)
	if (locale === "tr") return tr_misc_fairuse_title1(inputs)
	if (locale === "cs") return cs_misc_fairuse_title1(inputs)
	if (locale === "bg") return bg_misc_fairuse_title1(inputs)
	if (locale === "ru") return ru_misc_fairuse_title1(inputs)
	if (locale === "uk") return uk_misc_fairuse_title1(inputs)
	if (locale === "ar") return ar_misc_fairuse_title1(inputs)
	if (locale === "hi") return hi_misc_fairuse_title1(inputs)
	if (locale === "th") return th_misc_fairuse_title1(inputs)
	if (locale === "ja") return ja_misc_fairuse_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_title1(inputs)
	return ko_misc_fairuse_title1(inputs)
});
export { misc_fairuse_title1 as "misc.fairUse.title" }